import React from "react";
import { useNavigate } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";
import AuthLayout from "../../layouts/AuthLayout/AuthLayout";
import Button from "../../components/Button/Button";
import styles from "./Welcome.module.scss";
import { useTranslation } from "react-i18next";

const Welcome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGetStarted = () => {
    navigate("/login");
  };

  return (
    <AuthLayout>
      <div className={styles.page}>
        <div className={styles.iconCircle}>
          <Building2 />
        </div>
        <h1 className={styles.title}>{t("welcome.title")}</h1>
        <p className={styles.subtitle}>
          {t("welcome.subtitle")}
        </p>

        <div className={styles.features}>
          <div className={styles.featureItem}>
            <span className={styles.bullet} />
            <span>{t("welcome.features.trackAudits")}</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet} />
            <span>{t("welcome.features.manageDmaic")}</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet} />
            <span>{t("welcome.features.knowledgeBase")}</span>
          </div>
          <div className={styles.featureItem}>
            <span className={styles.bullet} />
            <span>{t("welcome.features.hsCodes")}</span>
          </div>
        </div>

        <Button
          text={t("welcome.cta")}
          onClick={handleGetStarted}
          icon={<ArrowRight />}
          iconPosition="right"
          className={styles.ctaButton}
        />
      </div>
    </AuthLayout>
  );
};

export default Welcome;
